module.exports = __webpack_public_path__ + "img/laboratorio_9-16_1080.7229262e.webp";